import React, { useState } from 'react'

import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import documentServices from '../documentServices';
import { useAlert } from '../../../../context/AlertContext';
import { useAppData } from '../../../../context/AppDataContext';
import { ArrowDropDown } from '@mui/icons-material';


function DocumentStatusUpdate({documentDetails,callBack}) {
  const {masters,getMasterLabel} = useAppData();
  const [dialogStatus,setDialogStatus] = useState(false);
  const {AppAlert} = useAlert();

  const updateStatus = (documentStatus) =>{
    let payload = {
      id:documentDetails.id,
      documentStatus:documentStatus
    }
    documentServices.save(payload).then(res=>{
      AppAlert("Status Updated");
      callBack();
    }).catch(error=>{
      AppAlert(error.msg, "error");
    }).finally(()=>{
      setDialogStatus(false);
    })
  }

  return (
    <>
      <Dialog
        open={dialogStatus}
        keepMounted
        onClose={()=>setDialogStatus(false)}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle>Update Status</DialogTitle>
        <DialogContent>
          <div className='row mt-3'>
            <div className='col-md-12'>
              {masters['document-status'].map(documentStatus=>
                <button className='btn btn-outline-primary me-3 mb-3' onClick={()=>updateStatus(documentStatus.value)} >{documentStatus.label}</button>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      
      <button className='btn btn-primary' onClick={()=>setDialogStatus(true)} >{getMasterLabel("document-status",documentDetails.documentStatus)} <ArrowDropDown/> </button>
      
      
    </>
  )
}

export default DocumentStatusUpdate